/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const RemovedDropShadow = styled.div({
  '& > div': {
    boxShadow: 'none',
  },
});

export const TextInputContainer = styled.div({
  marginTop: token('space.250'),
});
